import { render, staticRenderFns } from "./MultipleAutoMatching.vue?vue&type=template&id=d5220848&"
import script from "./MultipleAutoMatching.vue?vue&type=script&lang=js&"
export * from "./MultipleAutoMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports